__turbopack_context__.v({
  "chart-with-legend": "style-module-scss-module__VuYOTa__chart-with-legend",
  "legend": "style-module-scss-module__VuYOTa__legend",
  "legend-color": "style-module-scss-module__VuYOTa__legend-color",
  "legend-color-0": "style-module-scss-module__VuYOTa__legend-color-0",
  "legend-color-1": "style-module-scss-module__VuYOTa__legend-color-1",
  "legend-color-2": "style-module-scss-module__VuYOTa__legend-color-2",
  "legend-color-3": "style-module-scss-module__VuYOTa__legend-color-3",
  "legend-color-4": "style-module-scss-module__VuYOTa__legend-color-4",
  "legend-color-5": "style-module-scss-module__VuYOTa__legend-color-5",
  "legend-color-6": "style-module-scss-module__VuYOTa__legend-color-6",
  "legend-color-value": "style-module-scss-module__VuYOTa__legend-color-value",
  "legend-container": "style-module-scss-module__VuYOTa__legend-container",
  "title": "style-module-scss-module__VuYOTa__title",
});
